// The "Save to Price tool" checkbox's sticky default. Every price-entry
// surface (workbench line, edit modal, inline cell editor) starts from the
// last choice and writes the choice back on a successful save, so a desk that
// always publishes its negotiated prices ticks the box once. Per browser, not
// per user — it is a convenience, never state the backend depends on.

const KEY = 'inquiry-processor:sync-supplier-price';

export function readSyncPreference(): boolean {
  try {
    return localStorage.getItem(KEY) === 'true';
  } catch {
    return false; // storage blocked (private mode, sandbox) — the default stands
  }
}

export function writeSyncPreference(value: boolean): void {
  try {
    localStorage.setItem(KEY, value ? 'true' : 'false');
  } catch {
    // storage blocked — nothing to remember, nothing to break
  }
}
